//@flow
import api from 'api';

async function infoLogger({ name, log }) {
  try {
    api.postInfoLog({ name, log });
  } catch (error) {}
}

export default infoLogger;
